export const tenDigitsRegex = /^[0-9]{10}$/;
